<div class="right-side right-side-bg p-5">
  <h2>Dashboard</h2>
  <div>
    <!-- Dashboard Row -->
    <div class="card mb-3">
      <div class="card-header"><h2>Events</h2></div>
      <div class="card-body">
        <div class="row">
          <!-- Card 1 -->
          <!--<div class="col-lg-3 col-md-6 col-sm-12 mb-4">
      <div class="card text-white bg-primary">
        <div class="card-header">Total MSME Registration</div>
        <div class="card-body">
          <h5 class="card-title">1,200</h5>
          <p class="card-text">Total number of MSME users registered.</p>
        </div>
      </div>
    </div>-->

          <div class="col-md-3 mb-1" id="btnTotalEvents" (click)="CardRedirection($event)">
            <div class="card bg-gradient-primary box-shadow dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51 text-start">Total Created Events</h5>
                <div class="d-flex align-items-center">
                  <div class="display-4 fs-5">{{totalEvents}}</div>
                  <i class="bi bi-people ms-auto fs-4"></i>
                </div>               
              </div>
            </div>
          </div>

          <!-- Card 2 -->
          <!--<div class="col-lg-3 col-md-6 col-sm-12 mb-4">
      <div class="card text-white bg-success">
        <div class="card-header">Budget</div>
        <div class="card-body">
          <h5 class="card-title">₹ 30,10,500/-</h5>
          <p class="card-text">Total budget made this month.</p>
        </div>
      </div>
    </div>-->
          <div class="col-md-3 mb-1" id="btnCompletedEvents" (click)="CardRedirection($event)">
            <div class="card bg-gradient-success box-shadow dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51 text-start">Completed Events</h5>
                <div class="d-flex align-items-center">
                  <div class="display-4 fs-5">{{completedEvents}}</div>                 
                  <i class="bi bi-calendar-check ms-auto fs-4"></i>
                </div>
               
              </div>
            </div>
          </div>

          <!-- Card 3 -->
          <!--<div class="col-lg-3 col-md-6 col-sm-12 mb-4">
      <div class="card text-white bg-warning">
        <div class="card-header">Events</div>
        <div class="card-body">
          <h5 class="card-title">450</h5>
          <p class="card-text">Total Succeed Events in this month.</p>
        </div>
      </div>
    </div>-->
          <div class="col-md-3 mb-1" id="btnUpcomingEvents" (click)="CardRedirection($event)">
            <div class="card bg-gradient-warning box-shadow dash-height">
              <div class="card-body">
                <h5 class="card-title fs-51 text-start">Upcoming Events</h5>
                <div class="d-flex align-items-center">
                  <div class="display-4 fs-5">{{upcomingEvents}}</div>
                  <i class="bi bi-calendar-event ms-auto fs-4"></i>
                </div>
                <!--<p class="card-text crd-font2">Cancelled / Postponed Events</p>-->
              </div>
            </div>
          </div>

          <!--<div class="col-md-3">
      <div class="card bg-gradient-danger box-shadow mb-4">
        <div class="card-body">
          <h5 class="card-title crd-font">Attendance</h5>
          <div class="d-flex align-items-center">
            <div class="display-4 crd-font1">75%</div>
            <i class="bi bi-clipboard-check ms-auto fs-3"></i>

          </div>
          <p class="card-text crd-font2">Total Percentage of Attendance in Event.</p>
        </div>
      </div>
    </div>-->
        </div>
      </div>
    </div>

   

    <!-- Graph Section -->
    <!--<div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 mb-4">
      <div class="card">
        <div class="card-header">
          <h5>Target Budget </h5>
        </div>
        <div class="card-body">
          <canvas class="canvas" id="salesChart"></canvas>

        </div>
      </div>
    </div>
  </div>-->
  </div>
</div>
